export default [
  {
    path: '/ncm/',
    name: 'ncm',
    title: 'Ncm',
    component: () => import('../views/NcmView.vue'),
    redirect: { name: 'ncm-listar' },
    children: [
      {
        path: 'welcome',
        name: 'ncm-listar',
        component: () => import('../views/NcmWelcomeView.vue'),
        meta: {
          title: 'NCM',
        },
      },
      {
        path: 'add',
        name: 'ncm-cadastrar',
        component: () => import('../views/NcmFormView.vue'),
        meta: {
          title: 'Cadastrar NCM',
        },
      },
      {
        path: ':id',
        name: 'ncm-editar',
        component: () => import('../views/NcmFormView.vue'),
        meta: {
          title: 'Editar NCM',
        },
      },
    ],
  },
];
